import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { GlobalAuthResolver } from '../global-auth/global-auth.resolver';
import { TenantResolver } from '../tenant/tenant.resolver';
import { RestaurantInfoResolver } from '../restaurant-info/restaurant-info.resolver';
import { TokenService } from 'src/app/auth/token.service';
import { StoreResolver } from '../store/store.resolver';
import { TransactionResolver } from '../orders/transaction.resolver';

@Injectable({
  providedIn: 'root'
})
export class LogoutResolver {


  constructor(
    private _restaurantInfoResolver: RestaurantInfoResolver,
    private _tenantResolver: TenantResolver,
    private tokenService: TokenService,
    private navCtrl: NavController,
    private _globalAuthResolver: GlobalAuthResolver,
    private _storeResolver: StoreResolver,
    private transactionResolver: TransactionResolver,
    private router: Router,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private modalController: ModalController,
    private actionSheetController: ActionSheetController,
    private popoverController: PopoverController
  ) {

  }



  /**
   * logout
   */
  public logout() {
    void this.performLogout();
  }

  private async performLogout() {
    this.clearFocus();
    await this.dismissAllOverlays();
    this.clearOverlayDomLocks();

    this._globalAuthResolver.loggedIn.next(false);
    this._globalAuthResolver.profile.next(null);
    this._storeResolver.clear();
    this.tokenService.clearToken();
    this._tenantResolver.clearTenantName();
    this._restaurantInfoResolver.clearBasicInfo();
    this.transactionResolver.clearOrderCache();
    localStorage.removeItem('store');
    localStorage.removeItem('user');
    this.clearFocus();
    this.clearOverlayDomLocks();

    // Force full page reload to reset Ionic overlay/focus state completely.
    if (typeof window !== 'undefined') {
      const authUrl = this.router.serializeUrl(this.router.createUrlTree(['/auth']));
      window.location.replace(authUrl);
      return;
    }

    if (!this.router.url.startsWith('/auth')) {
      await this.navCtrl.navigateRoot('/auth');
    }
  }

  private async dismissAllOverlays() {
    try {
      const overlays = [
        this.alertController,
        this.loadingController,
        this.modalController,
        this.actionSheetController,
        this.popoverController,
      ];

      for (const controller of overlays) {
        let top = await controller.getTop();
        while (top) {
          await top.dismiss();
          top = await controller.getTop();
        }
      }
    } catch (err) {
      console.error('Failed to dismiss overlays during logout:', err);
    }
  }

  private clearOverlayDomLocks() {
    if (typeof document === 'undefined') {
      return;
    }

    document.body.classList.remove('backdrop-no-scroll', 'disable-scroll');

    const lingeringBackdrops = document.querySelectorAll('ion-backdrop');
    lingeringBackdrops.forEach((backdrop) => backdrop.remove());
  }

  private clearFocus() {
    if (typeof document === 'undefined') {
      return;
    }

    const activeElement = document.activeElement as HTMLElement | null;
    if (activeElement && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }
  }

}
